import { setQuillHTML } from "#/shared/lib/quill-html";

window.Sparkle = window.Sparkle || {};

(function () {
  window.Sparkle.prepareSendEmailForm = async function (modalSelector) {
    const composer = window.Sparkle.messageComposer;
    const root = composer.rootElement(modalSelector);
    if (!root) {
      return;
    }

    await composer.hydrate(root, "protected-message");

    const picker = await composer.hydrate(root, "message-template");
    composer.onTemplatePick(picker, (template) => applyTemplate(root, template));
  };

  function applyTemplate(root, template) {
    // Quill builds the editor after the picker binds, so it is resolved per apply.
    const editor = Quill.find(root.querySelector(".editor"));

    root.querySelector("#patient_email_message_mail_subject").value = template.dataset.subject ?? "";
    if (editor) {
      setQuillHTML(editor, template.dataset.body);
    }
  }
})();
